<figure class="avatar">
  <img class="avatar__image" [style]="style" [src]="avatarSrc" [alt]="alt" />
</figure>
